import React, { useEffect, useState, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { AuditoriaService } from '../../services/AuditoriaService';
import PageHeader from '../../components/ui/PageHeader';

const Auditoria = () => {
    const toast = useRef(null);
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 20,
        page: 0,
    });

    useEffect(() => {
        loadData(lazyParams.page, lazyParams.rows);
    }, [lazyParams]);

    const loadData = async (page, size) => {
        setLoading(true);
        try {
            const data = await AuditoriaService.getAll(page, size);
            // Validamos que 'content' exista debido a PageResponse en backend
            if (data && data.content) {
                setLogs(data.content);
                setTotalRecords(data.totalElements);
            } else {
                setLogs([]);
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Acceso Denegado', detail: 'Requiere permisos de administrador.', life: 3000 });
        } finally {
            setLoading(false);
        }
    };

    const onPage = (e) => {
        setLazyParams(e);
    };

    const severidadBody = (row) => {
        let severity = 'info';
        const accion = (row.accion || '').toUpperCase();
        if (accion.includes('ELIMINAR') || accion.includes('DELETE')) severity = 'danger';
        else if (accion.includes('CREAR') || accion.includes('INSERT')) severity = 'success';
        else if (accion.includes('ACTUALIZAR') || accion.includes('UPDATE')) severity = 'warning';
        
        return <Tag value={row.accion} severity={severity} />;
    };

    return (
        <div className="grid">
            <div className="col-12">
                <PageHeader 
                    title="Auditoría de Sistema" 
                    icon="pi pi-history" 
                    description="Historial detallado de todas las acciones registradas en el sistema (Logs)."
                />
                <div className="card">
                    <Toast ref={toast} />
                    <Toolbar className="mb-4 bg-transparent border-none" left={() => (
                        <Button label="Refrescar" icon="pi pi-refresh" onClick={() => loadData(lazyParams.page, lazyParams.rows)} />
                    )} />

                    <DataTable value={logs} lazy paginator first={lazyParams.first} rows={lazyParams.rows} totalRecords={totalRecords} onPage={onPage} loading={loading} responsiveLayout="scroll" emptyMessage="No hay registros de auditoría.">
                        <Column field="fecha" header="Fecha Transacción" body={(row) => new Date(row.fecha).toLocaleString()} sortable />
                        <Column field="usuario" header="Usuario" sortable />
                        <Column field="modulo" header="Módulo" sortable />
                        <Column field="accion" header="Acción" body={severidadBody} sortable />
                        <Column field="detalles" header="Detalles Técnicos" style={{ maxWidth: '300px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} />
                        <Column field="direccionIp" header="Dirección IP" />
                    </DataTable>
                </div>
            </div>
        </div>
    );
};

export default Auditoria;
